module.exports = __webpack_public_path__ + "static/img/default-user.09c4b7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/user/default-user.png
// module id = N31V
// module chunks = 15